import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from 'src/app/shared/models/security/role';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class RoleService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllRoles(): Observable<Role[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.roleUrl}s`,
			'getAllRoles'
		);
	}
}
